/**
 * Activity / Inflation pill-group toggle, rendered absolute-right next to
 * the centered page title. The active pill has an accent background, white
 * text, and a subtle inset shadow.
 */
import type { ViewMode } from '../types';

export interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (view: ViewMode) => void;
}

const OPTIONS: ReadonlyArray<{ value: ViewMode; label: string }> = [
  { value: 'gdp', label: 'Activity' },
  { value: 'inflation', label: 'Inflation' },
];

export default function ViewModeToggle({
  value,
  onChange,
}: ViewModeToggleProps): JSX.Element {
  return (
    <div
      className="absolute right-0 top-1/2 flex -translate-y-1/2 gap-0.5 rounded-lg bg-gray-100 p-1"
      role="radiogroup"
      aria-label="View"
    >
      {OPTIONS.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            data-view={opt.value}
            onClick={() => onChange(opt.value)}
            className={`rounded px-4 py-2 text-sm font-medium transition-all duration-200 ${
              active
                ? 'bg-[color:var(--accent)] text-white shadow-[0_1px_3px_rgba(0,0,0,0.1)]'
                : 'bg-transparent text-gray-600 hover:bg-gray-200 hover:text-gray-700'
            }`}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
